import scrollMonitor from 'scrollmonitor';
import toArray from './../../scripts/to-array';

toArray(document.querySelectorAll('[data-component="faq"]')).forEach((component) => {
  const animationSelector = '[data-faq-animation] [data-component="animation"]';
  const animation = component.querySelector(animationSelector);

  function playAnimation() {
    animation.animationController.goToAndPlay(1, true);
  }

  const animationWatcher = scrollMonitor.create(animation);
  animationWatcher.fullyEnterViewport(playAnimation);

  component.querySelector('[data-carousel-prev]').addEventListener('click', playAnimation);
  component.querySelector('[data-carousel-next]').addEventListener('click', playAnimation);

  component.addEventListener('click', (e) => {
    if (e.target && (e.target.matches('.pagination-dot'))) {
      playAnimation();
    }
  });
});
